<app-selector
  label="Para Drop Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="paraDropGameCoreService.paraDropGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="paraDropGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
